import {
  selectOpenModuleSet,
  selectMakeSetCurrentModuleSetAction,
} from './selectors';

/**
 * Toggles the visibility of a moduleset in the course navigation.
 */
export function toggleCourseNavigationModuleDisplay(setName) {
  return (dispatch, getState) => {
    const state = getState();

    const currentOpenSet = selectOpenModuleSet(state);
    const displaySet = currentOpenSet === setName ? null : setName;
    const action = selectMakeSetCurrentModuleSetAction(state)({
      setName: displaySet,
    });

    dispatch(action.toJS());
  };
}

export const closeModuleDisplay = () => (dispatch, getState) => {
  const state = getState();

  dispatch(
    selectMakeSetCurrentModuleSetAction(state)({
      setName: undefined,
    }).toJS()
  );
};
